module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 6
    }
  }, [_c('el-menu', {
    staticClass: "el-menu-vertical-demo"
  }, _vm._l((_vm.categoryList), function(item) {
    return _c('el-menu-item', {
      attrs: {
        "index": item.id
      },
      on: {
        "click": function($event) {
          _vm.handlerCategory(item.id)
        }
      }
    }, [_c('span', {
      attrs: {
        "slot": "title"
      },
      slot: "title"
    }, [_vm._v(_vm._s(item.name))])])
  }))], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 18
    }
  }, [_c('div', {
    staticClass: "cpy_info"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.contentData,
      "border": "",
      "stripe": ""
    }
  }, [_c('el-table-column', {
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', {
          on: {
            "click": function($event) {
              _vm.clickToRouter(scope.row.id)
            }
          }
        }, [_c('p', [_vm._v("\n                      " + _vm._s(scope.row.title) + "\n                      "), _c('span', {
          staticStyle: {
            "float": "right",
            "color": "#c8c8c8"
          }
        }, [_vm._v("发布时间:" + _vm._s(scope.row.publishTime))])])])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-pagination', {
    attrs: {
      "current-page": _vm.currentPage,
      "page-size": _vm.pageSize,
      "total": _vm.totalData,
      "layout": "total, prev, pager, next"
    },
    on: {
      "current-change": _vm.initData,
      "update:currentPage": function($event) {
        _vm.currentPage = $event
      }
    }
  })], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-51cf96b8!./~/vue-loader/lib/selector.js?type=template&index=0!./src/page/tenderingList.vue
// module id = 239
// module chunks = 2